<template>
  <div>
    <div class="mainPart">
      <el-form :model="verifyForm" inline class="checkForm" @submit.native.prevent>
        <el-form-item>
          <el-input v-model.trim="verifyForm.code" placeholder="请输入或扫描券卡" ref="refcode4" clearable @keyup.enter.native="submit">
            <i slot="prefix" class="iconsm pfIco"></i>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="verifyCode">验证</el-button>
        </el-form-item>
      </el-form>
      <el-row class="flexUI">
        <!--S 采集结果-->
        <el-col :span="18">
          <p class="commonTit flexBet">
            <span><b>券卡编码</b><em> (共 <i class="commonNum">{{codelist.length}}</i> 条)</em></span>
            <i class="redColor cursorHand" @click="codelist = []">一键清空</i>
          </p>
          <ul class="flexUpDownCenter cardCodeWrap" v-if="codelist.length>0">
            <li class="flexBet" v-for="(item, index) in codelist" :key="index">
              <em>{{item}}</em>
              <i title="删除" class="icondel" @click="removeCode(index, item)"></i>
            </li>
          </ul>
        </el-col>
        <el-col :span="5" :offset="1">
          <p class="commonTit"><b>快捷操作</b></p>
          <div class="quickLine">立即前往
              <a @click="download('定义激活')" title="定义激活">券卡定义激活</a>、
              <a @click="download('券卡激活')" title="券卡激活">券卡激活</a>、
              <a @click="download('券卡暂停')" title="券卡暂停">券卡暂停</a>、
              <a @click="download('券卡恢复')"  title="券卡恢复">券卡恢复</a>
          </div>
        </el-col>
      </el-row>
      <!--E 采集结果-->
      <p class="bottomBtn" v-if="codelist.length>0">
        <el-button type="primary" @click="downloadTxt">保存文本</el-button>
        <el-button type="primary" plain @click="codelist = []">清空</el-button>
      </p>
      
    </div>
  </div>
</template>
<script>
import { Message, MessageBox } from "element-ui";
import { saveAs } from 'file-saver';
export default {
  name: 'MembersVisit',
  data(){
    return {
      verifyForm:{       
        code:'', 
      },
      codelist:[],
      showList:false,
    }
  },
  filters:{

  },
  components: {

  },
  watch:{

  },
  // ============================================== 方法 ==============================================
  methods: {
    download(tetx){
      this.downloadTxt()
      this.$router.push({
              name:tetx,
              query: {
                typevery: 2
              }
            })
    }, 
    downloadTxt() {
      if(this.codelist.length>0){
        let text = ''
        if(this.codelist.length==0){
          text = this.codelist[0]
        }else{
          this.codelist.map((item,index)=>{
            if(index==0){
              text=item
            }else{
              text += '\r\n'+item
            }
          })
        }
        let strData = new Blob([text], { type: 'text/plain;charset=utf-8' });
        saveAs(strData, this.getNowDate()+"编码采集.txt");
        this.codelist=[]
      }else{

      }
    },
    // 格式化日对象
    getNowDate (){
      let date = new Date();
      let sign2 = ":";
      let year = date.getFullYear() // 年
      let month = date.getMonth() + 1; // 月
      let day = date.getDate(); // 日
      let hour = date.getHours(); // 时
      let minutes = date.getMinutes(); // 分
      let seconds = date.getSeconds() //秒
      // 给一位数的数据前面加 “0”
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (day >= 0 && day <= 9) {
        day = "0" + day;
      }
      if (hour >= 0 && hour <= 9) {
        hour = "0" + hour;
      }
      if (minutes >= 0 && minutes <= 9) {
        minutes = "0" + minutes;
      }
      if (seconds >= 0 && seconds <= 9) {
        seconds = "0" + seconds;
      }
      return year + "-" + month + "-" + day + " " + hour + sign2 + minutes + sign2 + seconds;
    },
    submit(){
      this.verifyCode()
    },
    //验证
    verifyCode(){
      let  url = this.verifyForm.code;
      let code=''
      if(!url.includes('https://th28.cn')&&url.length>20){
          this.$message.error('未授权设备,请联系技术客服！')
          this.verifyForm.code =''
          this.$refs.refcode4.focus();
          return
        }
      if(url&&url.indexOf('c=')!=-1){
        let index = url.indexOf('c=')
         code = url.substr(index+2, url.length)
      }else{
        code = this.verifyForm.code;
      }
      if(code==''){
        this.$refs.refcode4.focus();
          return
      }else if(!(code.length==16 ||code.length==20)){
        this.$message.error('请输入正确的编码！');
        this.verifyForm.code=''
        this.$refs.refcode4.focus();
          return
      }else if((this.codelist.includes(code))){
        this.$message.error('重复验证')
        this.verifyForm.code=''
      }else{
        this.codelist.push(code)
        this.verifyForm.code=''
      }
      this.$nextTick(() => {
          this.$refs.refcode4.focus();
      });
    },
    //移除编码
    removeCode(index, item){
      this.codelist.splice(index,1)
    },
  },
  created() {

  },
  mounted () {
    this.$nextTick(() => {
          this.$refs.refcode4.focus();
      });
  },
}
</script>
<style scoped>
.mainPart {padding: 20px; height:calc(100% - 40px); overflow-y: auto;}
.pfIco {font-size: 16px;color:#C0C4CC;}
/* .commonTit i {font-weight: lighter;} */
.checkForm .el-input{width:320px;}
.cardCodeWrap{margin:20px 0;max-height:calc(100vh - 270px);overflow-y:auto;position:relative;flex-wrap:wrap}
.cardCodeWrap li{width:250px;margin:5px 20px 5px 0;padding:0 10px 0 20px;height:40px;box-sizing:border-box}
.cardCodeWrap li em{width:75%;min-width:180px;display:inline-block; white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.cardCodeWrap li i{font-size:18px;cursor:pointer;color:#333;display: none;}
.cardCodeWrap li:hover{background:#f2f4f7}
.cardCodeWrap li:hover i{color:var(--main-color);display: inline-block;}
.quickLine {padding:20px; background:#FEF7F7;line-height:40px;margin:20px 0;}
.quickLine em {line-height: 40px; padding:0 15px; background:#f56262;color:#fff; font-size: 16px;margin-right:10px;}
.quickLine a {color:var(--main-color); padding:0 5px;}
</style>



// WEBPACK FOOTER //
// src/views/CardsFolder/CodesCollection.vue